<template src="./institutionsEditModal.html"></template>

<script>
import dmModalMixin from '../../../../dmFramework/dmJS/dmModalMixin';
import institutionsEndpoints from '../institutions.endpoints';

export default {
    name: 'institutions-edit-modal',
    mixins: [dmModalMixin],
    data() {
        return {
            dto: {},
            tabAnimation: { 
                previous: { 
                    effect: 'None', 
                },
                next: { 
                    effect: 'None', 
                } 
            },
            dropdownFields: {
                text: 'Text',
                value: 'Value',
            },
        }
    },
    computed: {
        lblTitle() {
          return this.modalData.mode === 'edit' ? 'Edit ' + this.modalData.dto.Name : 'Add Institution';
        },
        filteredIntermediaries() {
            return this.$store.state.intermediaryOptions.filter((int) => int.Value !== this.dto.PrimaryIntermediaryID);
        }
    },
    methods: {
        btnSaveOnClick() {
            if (this.modalData.mode === 'add') {
				institutionsEndpoints.create(this.dto)
					.then(() => {
						this.successClose(this.dto)
					})
            } else if (this.modalData.mode === 'edit') {
				institutionsEndpoints.update(this.dto)
					.then(() => {
						this.successClose(this.dto)
					})
            }
        },
        btnCancelOnClick() {
            this.closeModal();
        },
        selectPrimaryIntermediary() {
            this.dto.AdditionalIntermediaryIDs = this.dto.AdditionalIntermediaryIDs.filter((id) => id !== this.dto.PrimaryIntermediaryID);
        }
    },
    created() {
        this.dto = DMUtils.copy(this.modalData.dto);
    },

}
</script>